import { getDeviceSchema, VOICEMAIL } from "callable-data-objects";
import { CallableInput, CallableToggle } from "Components/Shared";
import CallableTextArea from "Components/Shared/CallableTextArea";
import FormSubmit from "Components/Shared/FormSubmit";
import TTSSelect from "Components/Shared/TTSSelect";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Form } from "semantic-ui-react";

const VoicemailEdit = () => {
  const { update, device } = useDevice();

  if (!device) return <Fragment />;

  return (
    <Formik
      initialValues={device}
      validationSchema={getDeviceSchema(VOICEMAIL)}
      onSubmit={(values, actions) => {
        update(values);
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <Field
            name='voicemail.text'
            label='Text'
            type='textarea'
            component={CallableTextArea}
          />
          <TTSSelect label='Language' name='voicemail.ttsLanguage' />
          <Field
            name='voicemail.finishOnKey'
            label='Finish On Key'
            type='text'
            component={CallableInput}
          />
          <Field
            name='voicemail.timeout'
            label='Timeout'
            type='number'
            min='3'
            max='10'
            component={CallableInput}
          />
          <Field
            name='voicemail.maxLength'
            label='Max VM Length'
            type='number'
            min='10'
            max='60'
            component={CallableInput}
          />
          <Field
            name='voicemail.emailRecipients[0]'
            label='Send to Email'
            component={CallableInput}
          />

          {/* <Field
            toggle
            name={`voicemail.transcribe`}
            label='Transcribe'
            component={CallableToggle}
          /> */}

          <Field
            toggle
            name={`voicemail.playBeep`}
            label='Beep'
            component={CallableToggle}
          />

          <FormSubmit name='Update' errors={props.errors} />
        </Form>
      )}
    </Formik>
  );
};

export default VoicemailEdit;
